import Vue from 'vue';
import VueRouter from 'vue-router';
import Content from '../views/Content.vue';
import ContentEdit from '../views/ContentEdit.vue';
import Blog from '../views/Blog.vue';
import BlogEdit from '../views/BlogEdit.vue';
import BlogCreate from '../views/BlogCreate.vue';
import Files from '../views/Files.vue';
import SignIn from '../views/SignIn.vue';
import ProjectSettings from '../views/ProjectSettings.vue';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  /* Sign In */
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn,
  },
  /* / Sign In */

  /* Content */
  {
    path: '/content/:section([a-z0-9]+?)',
    name: 'Content',
    component: Content,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/content/:contentId/:tab',
    name: 'ContentEdit',
    component: ContentEdit,
    meta: {
      requiresAuth: true,
    },
  },
  /* / Content */

  /* Blog */
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/blog/new',
    name: 'BlogCreate',
    component: BlogCreate,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/blog/:blogId/:tab',
    name: 'BlogEdit',
    component: BlogEdit,
    meta: {
      requiresAuth: true,
    },
  },
  /* / Blog */

  /* Files */
  {
    path: '/files',
    name: 'Files',
    component: Files,
    meta: {
      requiresAuth: true,
    },
  },
  /* / Files */

  /* Project Settings */
  {
    path: '/projectdetails',
    name: 'ProjectSettings',
    component: ProjectSettings,
    meta: {
      requiresAuth: true,
    },
  },
  /* / Project Settings */

  // always redirect to /content
  {
    path: '*',
    redirect: '/content/all',
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }

    let params;

    if (to.params && to.params.requestID) {
      params = to.params;
    }

    store.commit('authError', to);
    next({ name: 'SignIn', params });
  } else {
    next();
  }
});

export default router;
